export default __webpack_public_path__ + "static/media/refresh-loading.20d36f9e.svg";